module.exports = __webpack_public_path__ + "static/media/close-white.92d85624.svg";